import { matchPath } from 'react-router'
import { UserRole } from '@common/interfaces/user'
import { select, takeEvery } from 'redux-saga/effects'
import { ROUTES } from '../../constants/routes'
import { putPromise } from '../../helpers/redux'
import { show as showClient } from '../clientInfo/actions'
import { loadClientInfo } from '../profile/actions'
import { role } from '../profile/selectors'
import { CREATE_ADJUSTMENT } from './actions'

export function* updateAdjustmentSuccess() {
  yield takeEvery(CREATE_ADJUSTMENT, function* () {
    const path: string = window.location.pathname
    const userRole = (yield select(role)) as UserRole

    if (
      [UserRole.PORTFOLIO_USER, UserRole.PORTFOLIO_ADMIN].includes(userRole) &&
      matchPath(path, ROUTES.CLIENT_PAGE)
    ) {
      const match = matchPath({ path: ROUTES.CLIENT_PAGE }, path)
      if (match?.params?.id) {
        yield putPromise(showClient(match.params.id))
      }
    } else if (userRole === UserRole.CLIENT_USER && matchPath(path, ROUTES.HOMEPAGE)) {
      yield putPromise(loadClientInfo())
    }
  })
}
